( function () {
   
    'use strict';

    ( function ( $ ) {
       
        $(".shop-list").click(function () {
            if ($(this).hasClass('active')) {
            } else {
              var tabid = $(this).attr('id');
              $(".shop-list").removeClass('active');
              $(this).addClass('active');
              $(".shop-list-content").removeClass('active');
              $("#" + tabid + "-content").addClass("active");
            }
            return false;
        });
        $("#shop-1-content .shop-box").slice(0,3).show();
        $("#seeMore").click(function(e){
          e.preventDefault();
          $(".shop-box:hidden").slice(0,3).fadeIn("slow");
          
          if($(".shop-box:hidden").length == 0){
             $("#seeMore").fadeOut("slow");
            }
        });
        $("#shop-2-content .shop-box").slice(0,3).show();
        $("#seeMore1").click(function(e){
          e.preventDefault();
          $("#shop-2-content .shop-box:hidden").slice(0,3).fadeIn("slow");
          
          if($("#shop-2-content .shop-box:hidden").length == 0){
             $("#seeMore1").fadeOut("slow");
            }
        });
        $("#shop-3-content .shop-box").slice(0,3).show();
        $("#seeMore2").click(function(e){
          e.preventDefault();
          $("#shop-3-content .shop-box:hidden").slice(0,3).fadeIn("slow");
          
          if($("#shop-3-content .shop-box:hidden").length == 0){
             $("#seeMore2").fadeOut("slow");
            }
        });
        $("#shop-4-content .shop-box").slice(0,3).show();
        $("#seeMore3").click(function(e){
          e.preventDefault();
          $("#shop-4-content .shop-box:hidden").slice(0,3).fadeIn("slow");
          
          if($("#shop-4-content .shop-box:hidden").length == 0){
             $("#seeMore3").fadeOut("slow");
            }
        });
        $('button').click(function(e){
            var button_classes, value = +$('.counter').val();
            button_classes = $(e.currentTarget).prop('class');        
            if(button_classes.indexOf('up_count') !== -1){
                value = (value) + 1;            
            } else {
                value = (value) - 1;            
            }
            value = value < 0 ? 0 : value;
            $('.counter').val(value);
        });  
        $('.counter').click(function(){
            $(this).focus().select();
        });
    } )( jQuery );
} )();

